<template>
  <el-dialog
    title="群成员管理"
    :visible="visible"
    width="800px"
    @close="handleClose"
  >
    <div v-if="groupData" class="group-members">
      <!-- 群组信息 -->
      <div class="group-header">
        <div class="group-info">
          <el-avatar :size="40" :src="groupData.avatar">
            {{ groupData.groupName ? groupData.groupName.charAt(0) : "G" }}
          </el-avatar>
          <div style="margin-left: 12px">
            <h3>{{ groupData.groupName }}</h3>
            <p style="color: #999; margin: 0">
              成员数: {{ members.length }} /
              {{ groupData.maxMemberCount || 500 }}
            </p>
          </div>
        </div>
      </div>

      <!-- 搜索 -->
      <div class="search-form" style="margin: 20px 0">
        <el-input
          v-model="searchKeyword"
          placeholder="搜索成员昵称"
          style="width: 200px; margin-right: 10px"
          clearable
        />
        <el-button @click="loadMembers">搜索</el-button>
        <el-button type="primary" @click="showAddMember">添加成员</el-button>
      </div>

      <!-- 成员列表 -->
      <el-table :data="filteredMembers" style="width: 100%">
        <el-table-column prop="nickName" label="昵称" width="150">
          <template slot-scope="scope">
            <div class="member-info">
              <el-avatar :size="32" :src="scope.row.avatar">
                {{ scope.row.nickName ? scope.row.nickName.charAt(0) : "U" }}
              </el-avatar>
              <span style="margin-left: 8px">{{ scope.row.nickName }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="userId" label="用户ID" width="120" />

        <el-table-column prop="role" label="角色" width="100">
          <template slot-scope="scope">
            <el-tag :type="getRoleTagType(scope.row.role)" size="small">
              {{ scope.row.role | memberRoleText }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="joinTime" label="加入时间" width="150">
          <template slot-scope="scope">
            {{ scope.row.joinTime | formatDate }}
          </template>
        </el-table-column>

        <el-table-column prop="lastActiveTime" label="最后活跃" width="150">
          <template slot-scope="scope">
            {{ scope.row.lastActiveTime | formatDate }}
          </template>
        </el-table-column>

        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-dropdown
              @command="(command) => handleMemberCommand(command, scope.row)"
            >
              <el-button size="mini">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="scope.row.role === 'member'"
                  command="setAdmin"
                >
                  设为管理员
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="scope.row.role === 'admin'"
                  command="removeAdmin"
                >
                  取消管理员
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="scope.row.role !== 'owner'"
                  command="remove"
                  divided
                >
                  移出群组
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <!-- <div class="pagination" style="text-align: center; margin-top: 20px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next"
          :total="pagination.total"
        />
      </div> -->
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
    </div>

    <!-- 添加成员对话框 -->
    <el-dialog
      title="添加群成员"
      :visible.sync="addMemberVisible"
      width="500px"
      append-to-body
    >
      <el-form :model="addMemberForm" label-width="80px">
        <el-form-item label="用户ID">
          <el-input
            v-model="addMemberForm.userId"
            placeholder="请输入要添加的用户ID"
          />
        </el-form-item>
        <el-form-item label="角色">
          <el-radio-group v-model="addMemberForm.role">
            <el-radio label="member">普通成员</el-radio>
            <el-radio label="admin">管理员</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addMemberVisible = false">取消</el-button>
        <el-button type="primary" @click="handleAddMember">确定</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import {
  getGroupMembers,
  addGroupMember,
  removeGroupMember,
  updateMemberRole,
} from "@/api/group";

export default {
  name: "GroupMembers",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    groupData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      members: [],
      searchKeyword: "",
      pagination: {
        page: 1,
        size: 20,
        total: 0,
      },
      addMemberVisible: false,
      addMemberForm: {
        userId: "",
        role: "member",
      },
    };
  },
  computed: {
    filteredMembers() {
      if (!this.searchKeyword) {
        return this.members;
      }
      return this.members.filter((member) =>
        member.nickName.toLowerCase().includes(this.searchKeyword.toLowerCase())
      );
    },
  },
  watch: {
    visible(val) {
      if (val && this.groupData) {
        this.loadMembers();
      }
    },
  },
  methods: {
    async loadMembers() {
      try {
        const params = {
          page: this.pagination.page,
          size: this.pagination.size,
          keyword: this.searchKeyword,
        };
        const response = await getGroupMembers(this.groupData.id, params);
        this.members = response.data.records || response.data || [];
        this.pagination.total = response.data.total || this.members.length;
      } catch (error) {
        console.error("加载群成员失败:", error);
        // 模拟数据
        this.members = [
          {
            id: 1,
            userId: "user001",
            nickName: "群主用户",
            role: "owner",
            joinTime: new Date(Date.now() - 86400000 * 30).toISOString(),
            lastActiveTime: new Date().toISOString(),
          },
          {
            id: 2,
            userId: "user002",
            nickName: "管理员1",
            role: "admin",
            joinTime: new Date(Date.now() - 86400000 * 20).toISOString(),
            lastActiveTime: new Date(Date.now() - 3600000).toISOString(),
          },
          {
            id: 3,
            userId: "user003",
            nickName: "普通成员1",
            role: "member",
            joinTime: new Date(Date.now() - 86400000 * 10).toISOString(),
            lastActiveTime: new Date(Date.now() - 7200000).toISOString(),
          },
        ];
        this.pagination.total = this.members.length;
      }
    },

    getRoleTagType(role) {
      switch (role) {
        case "owner":
          return "danger";
        case "admin":
          return "warning";
        default:
          return "info";
      }
    },

    async handleMemberCommand(command, member) {
      switch (command) {
        case "setAdmin":
          await this.updateMemberRole(member, "admin");
          break;
        case "removeAdmin":
          await this.updateMemberRole(member, "member");
          break;
        case "remove":
          await this.removeMember(member);
          break;
      }
    },

    async updateMemberRole(member, newRole) {
      try {
        await this.$confirm(
          `确定要将"${member.nickName}"${
            newRole === "admin" ? "设为管理员" : "取消管理员"
          }吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );

        await updateMemberRole(this.groupData.id, member.id, newRole);
        this.$message.success("操作成功");
        this.loadMembers();
      } catch (error) {
        if (error !== "cancel") {
          console.error("更新成员角色失败:", error);
          this.$message.error("操作失败");
        }
      }
    },

    async removeMember(member) {
      try {
        await this.$confirm(
          `确定要将"${member.nickName}"移出群组吗？`,
          "警告",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );

        await removeGroupMember(this.groupData.id, member.id);
        this.$message.success("移除成功");
        this.loadMembers();
      } catch (error) {
        if (error !== "cancel") {
          console.error("移除成员失败:", error);
          this.$message.error("移除失败");
        }
      }
    },

    showAddMember() {
      this.addMemberForm = {
        userId: "",
        role: "member",
      };
      this.addMemberVisible = true;
    },

    async handleAddMember() {
      if (!this.addMemberForm.userId) {
        this.$message.error("请输入用户ID");
        return;
      }

      try {
        await addGroupMember(this.groupData.id, this.addMemberForm);
        this.$message.success("添加成功");
        this.addMemberVisible = false;
        this.loadMembers();
      } catch (error) {
        console.error("添加成员失败:", error);
        this.$message.error("添加失败");
      }
    },

    handleSizeChange(size) {
      this.pagination.size = size;
      this.loadMembers();
    },

    handleCurrentChange(page) {
      this.pagination.page = page;
      this.loadMembers();
    },

    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.group-members {
  .group-header {
    padding: 16px;
    background: #f5f7fa;
    border-radius: 4px;
    margin-bottom: 20px;
  }

  .group-info {
    display: flex;
    align-items: center;

    h3 {
      margin: 0 0 4px 0;
      color: #303133;
    }
  }

  .member-info {
    display: flex;
    align-items: center;
  }
}
</style>
